import { getSymbol, Icon, TreeSymbol } from '@mairistem/finances-utils';
import React from 'react';
import type BaseFeuilleSaisie from '../classes/feuilleSaisies/BaseFeuilleSaisie';
import TypeRegroupement from '../constants/feuilleSaisie/typeRegroupement';
import type TreeRow from '../interfaces/feuilleSaisie/treeRow';
import type Filters from '../interfaces/simulation/filters';

export const getRowFilters = (
	row: TreeRow,
	filters: Filters,
	feuilleSaisie: BaseFeuilleSaisie,
	withLibelle: boolean = false,
): any => {
	let parent = row;
	// on prend la depth + 1 pour compter le premier niveau (tab)
	const initialDepth = (getSymbol(row, TreeSymbol.DEPTH) ?? 0) + 1;
	let depth = initialDepth;
	// On prends notre item actuel, et on lui rajoute ses enfants
	const fetchFilters = {
		...filters,
	};

	while (parent !== undefined) {
		const nodes = feuilleSaisie.nodes[depth];
		nodes.forEach((node) => {
			if (node.code !== TypeRegroupement.IMPUTATION) {
				fetchFilters[node.code] = parent[node.codeColumnName];
				if (withLibelle) {
					fetchFilters[node.libelleColumnName] = parent[node.libelleColumnName];
				}
			}
		});
		depth--;
		parent = getSymbol(parent, TreeSymbol.PARENT);
	}

	return fetchFilters;
};

export const renderTreeToggle = (
	rowData: TreeRow,
	isExpanded: boolean,
	codeLoading: string,
) => (
	<Icon
		color="blue"
		data-testid={`treeToggle${rowData?.keyOrder}`}
		loading={rowData.key === codeLoading}
		name={
			rowData.key === codeLoading
				? 'circle notch'
				: `chevron ${isExpanded ? 'down' : 'right'}`
		}
	/>
);

export const isRowCaduque = (rowData: TreeRow): boolean =>
	rowData?.ana_caduque ||
	rowData?.art_caduque ||
	rowData?.cha_caduque ||
	rowData?.fon_caduque ||
	rowData?.imp_caduque ||
	rowData?.ope_caduque ||
	rowData?.ven_caduque;
